import React from 'react';
import Styled from 'styled';

import defaultStyles, { InputStyles } from './input.scss';
import SVGIcon from 'lib/images/svg-icon/svg-icon';
import { Props as IconProps } from 'lib/images/svg-image/svg-image';

import search from 'four-nets/icons/svg/icon_search.svg';

export const Icon = (props: Omit<IconProps, 'styles'>) => <SVGIcon style={{ image: defaultStyles.image }} {...props} />;
export interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
    icon?: React.ReactNode;
    styles?: InputStyles;
}

class Input extends React.PureComponent<Props> {
    static defaultProps = {
        icon: <Icon src={search} />,
    };

    render() {
        const { styles, icon, ...rest } = this.props;

        return (
            <div className={styles!.wrapper}>
                <input {...rest} className={styles!.input} />
                <div className={styles!.icon}>{icon}</div>
            </div>
        );
    }
}

export default Styled(defaultStyles)(Input);
